module.exports = __webpack_public_path__ + "static/media/14.928b7c21.jpg";